<!-- 项目文件 -->
<template>
<div>
    <Header :Logo="logo" :Waytype="waytype" ref="mychild" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
    <div class="w1200 mauto">
        <div class=" pt30 pb20 ">
            <div class="textc mt20 mb20">
                <p class="fs36 c333 disinblock posre">
                    <span class="border-bottom1">
                        驾驶培训
                    </span>
                </p>
            </div>
            <div>
                <p class="fs16 c000 pb20 fbold">
                    为商家提供专属经营流量池
                </p>
                <p class="fs16 c333 pb20 lh26 textindent2">
                    为合作伙伴提供技术、品牌、产品与服务支持,共建经营用户流量池,支持各种经营模式,广告引流、电商营销、本地服务,解决合作伙伴客户流量经营烦恼,共同
                    打造合作伙伴私域流量池。
                </p>
                <div class="overflow posre pb30">
                    <div @click="prve()" class="posab left0 zindex9999 cursor" style="top: 45%;">
                        <img class="w60 h60" src="../../public/img/jiantou2.png" alt="">
                    </div>
                    <div @click="next()" class="posab right0 zindex9999 cursor" style="top: 45%;">
                        <img class="w60 h60" src="../../public/img/jiantou1.png" alt="">
                    </div>
                    <transition name="fade33" mode="out-in">
                        <div class="w100p  pt20 textc posre h100p" ref="element" @mousemove="showF()" v-show="banner==1">
                            <div class="w100p h100p posab top0 left0 zindex999 overflow">
                
                                <transition name="custom-classes-transition" enter-active-class="animated tada"
                                    leave-active-class="animated bounceOutRight">
                                    <div class="w148 h85 bg145 disinblock posab top240 left15p" v-if="showS==1">
                                        <div class="pl10 pr10 pt12">
                                            <p class="fs14 c333 ">学员APP：在线约课 练车时间，自己做主</p>
                                            <p @click="onStudents(1)" class="fs12 c349 pt3 cursor">查看界面></p>
                                        </div>
                                    </div>
                                </transition>
                
                                <transition name="slide-fade">
                                    <div class="w148 h85 bg145 disinblock posab top145 left45p" v-if="showP==1">
                                        <div class="pl10 pr10 pt12">
                                            <p class="fs14 c333  ">校长APP：在线管理 统筹经营，掌控全局</p>
                                            <p @click="onStudents(2)" class="fs12 c349 pt3 cursor">查看界面></p>
                                        </div>
                                    </div>
                                </transition>
                
                
                
                                <transition name="moveR">
                                    <div class="w148 h85 bg145 disinblock posab top500 left70" v-if="showT==1">
                                        <div class="pl10 pr10 pt12">
                                            <p class="fs14 c333  ">教练APP：在线教学 教学计划 一目了然</p>
                                            <p @click="onStudents(4)" class="fs12 c349 pt3 cursor">查看界面></p>
                                        </div>
                                    </div>
                                </transition>
                
                
                
                
                                <!-- 学员 -->
                                <transition name="moveR">
                                    <div v-show="showStudents==1" class=" disinblock posab top100 " style="left: 28%;">
                                        <img class="imgauto posre zindex1" src="../../public/img/img146.png" alt="">
                                    </div>
                                </transition>
                
                
                                <!-- 校长 -->
                                <transition name="moveR">
                                    <div v-show="showStudents==2" class=" disinblock posab" style="left: 58%;top: 60px;">
                                        <img class="imgauto posre zindex1" src="../../public/img/img144.png" alt="">
                                    </div>
                                </transition>
                
                                <!-- 教练 -->
                                <transition name="moveR">
                                    <div v-show="showStudents==4" class=" disinblock posab " style="left: 54%;top: 240px;">
                                        <img class="imgauto posre zindex1" src="../../public/img/img147.png" alt="">
                                    </div>
                                </transition>
                
                
                            </div>
                            <img class="imgauto posre " style="width: 85%;" src="../../public/img/img7.png" alt="">
                        </div>
                    </transition>
                    <transition name="fade33" mode="out-in">
                        <div class="w100p  pt20 textc posre h100p" @mousemove="showF2()" ref="element" v-show="banner==2">
                            <div class="w100p h100p posab  top0 left0 zindex999 overflow">
                
                                <transition name="fade22">
                                    <div v-if="isShow1==1" class="w148 h85 bg145 disinblock posab " style="left: 35%;top:300px;">
                                        <div class="pl10 pr10 pt12">
                                            <p class="fs14 c333 ">学员APP:预的考试 随时随地 反馈及时</p>
                                            <p @click="onStudents(5)" class="fs12 c349 pt3 cursor">查看界面></p>
                                        </div>
                                    </div>
                                </transition>
                
                                <transition name="fade22">
                                    <div v-if="isShow2==1" class="w148 h85 bg145 disinblock posab " style="left: 55%;top: 300px;">
                                        <div class="pl10 pr10 pt12">
                                            <p class="fs14 c333  ">教练APP :掌握洋情 统计数据 类別清晰</p>
                                            <p @click="onStudents(6)" class="fs12 c349 pt3 cursor">查看界面></p>
                                        </div>
                                    </div>
                                </transition>
                
                
                
                
                                <!-- 学员 -->
                                <transition name="fade22">
                                    <div v-show="showStudents==5" class=" disinblock posab top100 " style="left: 18%;">
                                        <img class="imgauto posre zindex1" src="../../public/img/img266.png" alt="">
                                    </div>
                                </transition>
                
                
                
                
                                <!-- 教练 -->
                                <transition name="fade22">
                                    <div v-show="showStudents==6" class=" disinblock posab top100" style="left: 70%;">
                                        <img class="imgauto posre zindex1" src="../../public/img/img267.png" alt="">
                                    </div>
                                </transition>
                
                
                            </div>
                            <img class="imgauto posre " style="width: 85%;" src="../../public/img/img7_1.png" alt="">
                        </div>
                    </transition>
                </div>
                <div class="fs16 c333 pb50 lh26 ">
                    <P class="fs16 c000 pb20 fbold">盈利模式</P>
                    <P>1、合作伙伴通过平台招商引入流量合作/经营，80%收益归合作伙伴所有。</P>
                    <P>2、平台引入推广的产品合作，合作伙伴可获取其推广区域成交价格20%的推广费用。</P>
                    <P>3、合作伙伴可获得长期流量收益稳定。</P>
                </div>
                
                <div class=" pb20 fs16 c333 lh26">
                    <P class="fs16 c000 pb20  fbold">准入条件</P>
                
                    <P>1)必须依法注册，可以独立承担民事责任的企业单位/可以独立承担民事责任的个人。</P>
                    <P>2)良好的客户覆盖服务能力：市场开拓和市场驾驭能力强，有驾培行业客户资源优势和较强的客户服务能力者优先考虑。</P>
                    <P>3)熟悉代理招募地区和驾培驾考行业发展状况，熟悉驾培驾考行业广告业务特点和发展趋势，具有丰富的互联网经营经验者优先。</P>
                    <P>4)良好渠道开拓运营能力：认同公司的渠道管理理念和经营模式，具有真诚、长期合作意向。</P>
                    <P>5)良好的业绩营收能力：能准确预估市场份额，并使e学e驾市场影响力与业务量到达本区域行业前列，同时具备较强的营销活动策划、组织、执行能力，能接受公司安排的业绩任务。</P>
                    <P>6)有竞争力（代理）意识：认同e学e驾的产品理念，对驾培市场有憧憬，并给出有竞争力的业务量。</P>
                </div>
                <div class="pl40 pr40 pb20">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="">
                                加盟入驻
                            </span>
                        </p>
                    </div>
                    <div class="textc">
                        <div class="pb30">
                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img294.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">提交加盟</span>
                            </p>

                            <p class="disinblock vermid  ">
                                <img class="h2 w180 vermid" src="../../public/img/img298.png" alt="">
                            </p>

                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img295.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">登陆入驻</span>
                            </p>

                            <p class="disinblock vermid ">
                                <img class="h2 w180 vermid" src="../../public/img/img298.png" alt="">
                            </p>

                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img296.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">平台使用</span>
                            </p>

                            <p class="disinblock vermid ">
                                <img class="h2 w180 vermid" src="../../public/img/img298.png" alt="">
                            </p>

                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img297.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">入驻推广</span>
                            </p>
                        </div>
                        <div class="pt60  textc pb20">
                            <span @click="openChild()" class="cfff cursor bg1f8 bradius5 fs18 disinblock fbold h50 lh50 w240">合作申请</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer ></Footer>
</div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img87.png'),
                titleList: 3,
                link: 1,
                logo: 'coop',
                color: 2,
                showS: 0,
                showP: 0,
                showT: 0,
                showStudents: 0,
                isShow1: 0,
                isShow2: 0,
                banner: 1,
                waytype: 1
            };
        },
        components: {
            Header,
            Footer,

        },
        methods: {
            prve() {
                if (this.banner > 1) {
                    this.banner = 1
                } else {
                    this.banner++;
                }
            },
            next() {
                if (this.banner < 2) {
                    this.banner = 2
                } else {
                    this.banner--;
                }
            },
            activeShow() {
                this.actionShow = !this.actionShow;
            },
            activeIndex(id) {
                this.index = id;
            },
            onStudents(id) {
                this.showStudents = id
            },
            moveImg(id) {
                this.showImg = id;
            },
            showF() {

                setTimeout(() => {
                    this.showS = 1
                }, 100);
                setTimeout(() => {
                    this.showP = 1
                }, 300);

                setTimeout(() => {
                    this.showT = 1
                }, 500);
            },
            showF2() {

                setTimeout(() => {
                    this.isShow1 = 1
                }, 100);
                setTimeout(() => {
                    this.isShow2 = 1
                }, 300);
            },
            openChild() {
                this.$refs.mychild.foo();
            }
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .fade22-enter-active {
        transition: opacity 1s;
        position: absolute;
    }
    
    .fade22-enter,
    .fade22-leave-to {
        opacity: 0;
    }
    
    .fade33-enter-active {
        transition: opacity 1s;
        /* position: absolute; */
    }
    
    .fade33-enter,
    .fade33-leave-to {
        opacity: 0;
    }
    
    .plus-icon-enter-active {
        transition: opacity .1s;
    }
    
    .plus-icon-enter {
        opacity: 0;
    }
    
    .plus-icon-leave-active {
        transition: opacity .1s;
    }
    
    .plus-icon-leave-to {
        opacity: 0;
    }
    
    .plus-icon-enter-to {
        opacity: 1;
    }
    
    .moveR-enter-active,
    .moveR-leave-active {
        transition: all 0.3s linear;
        transform: translateX(0);
    }
    
    .moveR-enter,
    .moveR-leave {
        transform: translateX(100%);
    }
    
    .moveR-leave-to {
        transform: translateX(100%);
    }
    
    .moveL-enter-active,
    .moveL-leave-active {
        transition: all 0.3s linear;
        transform: translateX(0%);
    }
    
    .moveL-enter,
    .moveL-leave {
        transform: translateX(-100%);
    }
    
    .moveL-leave-to {
        transform: translateX(-100%);
    }
    
    .bg145 {
        background-image: url('../../public/img/img145.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
</style>